import { useTranslation } from "react-i18next";
import type { TipoServicio } from "@/services/ordenes";

const VARIANTS: Record<TipoServicio, string> = {
  AMBULATORIO: "bg-blue-100 text-blue-800 border-blue-200",
  EMERGENCIA: "bg-red-100 text-red-800 border-red-200",
  HOSPITALIZACION: "bg-purple-100 text-purple-800 border-purple-200",
  DOMICILIO: "bg-orange-100 text-orange-800 border-orange-200",
};

interface TipoServicioBadgeProps {
  tipo: TipoServicio;
  className?: string;
}

export function TipoServicioBadge({ tipo, className = "" }: TipoServicioBadgeProps) {
  const { t } = useTranslation();
  const label = t(`ordenes.serviceType.${tipo.toLowerCase()}`, { defaultValue: tipo });

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${VARIANTS[tipo] ?? "bg-gray-100 text-gray-800 border-gray-200"} ${className}`}
    >
      {label}
    </span>
  );
}
